module.exports = __webpack_public_path__ + "a9346cf2dc2afcbc0416c9582c534ab5.pdf";